import { Button } from '@mui/material';

import { buttonSx } from './styles';

import type * as React from 'react';
import type { ButtonProps as MuiButtonProps } from '@mui/material';
import type { ThemeProps } from '@toolbox/style/theme/common/ThemeProvider/ThemeProvider';

export interface ButtonProps
  extends Omit<MuiButtonProps, 'variant' | 'color'>,
    React.PropsWithChildren {
  primary?: boolean;
}

const ButtonCmp: React.FC<ButtonProps> = ({ children, primary = false, sx, ...other }) => {
  return (
    <Button
      sx={buttonSx(primary, sx)}
      variant={primary ? 'contained' : 'outlined'}
      {...(other as ThemeProps)}
    >
      {children}
    </Button>
  );
};

export default ButtonCmp;
